import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { AttendeeMappingFormViewModel } from './attendee-mapping-form.viewmodel';
import { ContactRow, ContactsListHeader } from './attendee-mapping-contacts-table';
import { EMAIL_TEXT, FIRST_NAME_TEXT, LAST_NAME_TEXT } from '../../attendees.texts';
import { NO_CONTACTS_FOUND_TEXT, SEARCH_TEXT } from './attendee-mapping-form.texts';
import KnovioPreviewSpinner from '../../../../../global/spinner/knovio-preview-spinner';

const SearchResults = observer(({ vm }: { vm: AttendeeMappingFormViewModel }) => {
    if (vm.searching) return <KnovioPreviewSpinner />;
    if (!vm.searchPerformed) return null;

    if (!vm.searchResults.length) {
        return (
            <span className='attendee-mapping-form__hint'>
                <FormattedMessage {...NO_CONTACTS_FOUND_TEXT} />
            </span>
        );
    }
    const editRolodexContactPermission = vm.hasEditRolodexContactPermission();

    return (
        <>
            <ContactsListHeader withIconOffset />
            <div className='attendee-mapping-form__results'>
                {vm.searchResults.map(contact => (
                    <ContactRow
                        key={contact.contactId}
                        contact={contact}
                        isSelected={vm.selectedContactId === contact.contactId}
                        onSelect={() => vm.selectContact(contact.contactId)}
                        openEditRolodexContactPopup={vm.openEditRolodexContactPopup}
                        editRolodexContactPermission={editRolodexContactPermission}
                    />
                ))}
            </div>
        </>
    );
});

export const ContactSearchSection = observer(({ vm }: { vm: AttendeeMappingFormViewModel }) => (
    <>
        <div className='flex'>
            <FormField className='m-right-8px' label={<FormattedMessage {...FIRST_NAME_TEXT} />}>
                <input
                    className='oe-form-field__control'
                    value={vm.firstName}
                    onChange={({ target: { value } }) => vm.setFirstName(value)}
                />
            </FormField>
            <FormField label={<FormattedMessage {...LAST_NAME_TEXT} />}>
                <input
                    className='oe-form-field__control'
                    value={vm.lastName}
                    onChange={({ target: { value } }) => vm.setLastName(value)}
                />
            </FormField>
        </div>
        <FormField label={<FormattedMessage {...EMAIL_TEXT} />}>
            <input
                className='oe-form-field__control'
                value={vm.primaryEmail}
                onChange={({ target: { value } }) => vm.setEmail(value)}
            />
        </FormField>
        <DefaultButton
            text={<FormattedMessage {...SEARCH_TEXT} />}
            modifier='fat'
            disabled={!vm.canSearch()}
            onClick={vm.search}
            className='attendee-mapping-form__search-button'
        />
        <SearchResults vm={vm} />
    </>
));
